import api from './api';

const collegeService = {
  getColleges: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/colleges?${queryString}`);
    return response.data;
  },

  getCollegeById: async (id) => {
    const response = await api.get(`/colleges/${id}`);
    return response.data;
  },

  createCollege: async (collegeData) => {
    const response = await api.post('/colleges', collegeData);
    return response.data;
  },

  updateCollege: async (id, collegeData) => {
    const response = await api.put(`/colleges/${id}`, collegeData);
    return response.data;
  },

  deleteCollege: async (id) => {
    const response = await api.delete(`/colleges/${id}`);
    return response.data;
  },
};

export default collegeService;